export var DEFAULT_CONFIG = {
  stargateRoot: '/gateway/api',
  permsServiceUrl: '/gateway/api/permissions',
  publicApiRoot: '/gateway/api/public',
  invitationsServiceUrl: '/gateway/api/invitations',
  collaborationGraphUrl: '/gateway/api/collaboration'
};